import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = { class: "form-row" }
const _hoisted_4 = { class: "grid w-ful grid-cols-2 gap-4 px-2 mt-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ยกเลิก")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("ยืนยัน")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonModalWithPreset = _resolveComponent("CommonModalWithPreset")!
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_CommonForm = _resolveComponent("CommonForm")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_AdvancePageColumn = _resolveComponent("AdvancePageColumn")!

  return (_openBlock(), _createBlock(_component_AdvancePageColumn, { class: "common-form-with-vendor-editor" }, {
    default: _withCtx(() => [
      _createVNode(_component_CommonModalWithPreset, {
        type: "success-close",
        ref: "confirmModal",
        onDone: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'VendorList' })))
      }, null, 512),
      _createVNode(_component_Panel, {
        title: `${_ctx.edit ? 'แก้ไข' : 'เพิ่ม'}ข้อมูลขนส่ง`,
        style: {"max-width":"800px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_Panel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CommonForm, { form: _ctx.form }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_CommonInput, {
                            modelValue: _ctx.form.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                            label: "ชื่อขนส่ง",
                            rules: "required",
                            placeholder: "ระบุชื่อขนส่ง"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_CommonInput, {
                            modelValue: _ctx.form.code,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.code) = $event)),
                            label: "รหัสขนส่ง",
                            rules: "required",
                            placeholder: "ระบุรหัสขนส่ง"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_CommonInput, {
                            modelValue: _ctx.form.webhook,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.webhook) = $event)),
                            label: "ลิ้งค์ Webhook",
                            placeholder: "ลิ้งค์สำหรับ API"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_CommonButton, {
                            small: "",
                            type: "button",
                            level: "gray",
                            block: "",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.go(-1)))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CommonButton, {
                            small: "",
                            type: "submit",
                            block: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["form"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}